Application.Forms.Validators.RealTimeAllValidator = $.extend(true, $.extend(true, {}, Application.Forms.Validators.BaseValidator), {
    on: {
        submit: true,
        change: true,
        keydown: true,
        focus: true,
        blur: true,
        ready: true,
    },
    onError: function (el, message) {

        var $form = $(el).closest('form')

        // always reaply the error class, to allow CSS animations to replay
        $form.removeClass('error');

        setTimeout(function(){

            $form.addClass('error');

        }, 10);

    },
    onSuccess: function (el) {

        var $form = $(el).closest('form')
        $form.removeClass('error');

    }
});